import styled, { createGlobalStyle } from 'styled-components';
import { Col, Row } from '@vds/grids';
import { isDesktopResolution, isExpressCheckout } from './Helpers';

export const Grid = styled.div``;

export const TileBody = styled.div`
  margin-top: ${(props) => props.top};
  margin-bottom: ${(props) => props.bottom};
  margin-right: ${(props) => props.right};
  margin-left: ${(props) => props.left};
  display: flex;
  justify-content: space-between;
`;

export const Margin = styled.div`
  margin-top: ${(props) => props.top};
  margin-right: ${(props) => props.right};
  margin-bottom: ${(props) => props.bottom};
  margin-left: ${(props) => props.left};
`;
/* top | right | bottom | left */
export const Padding = styled.div`
  padding-top: ${(props) => props.top};
  padding-right: ${(props) => props.right};
  padding-bottom: ${(props) => props.bottom};
  padding-left: ${(props) => props.left};
`;

export const AGRID = styled.div`
  padding-right: ${(props) => (props.pageContext === 'ExpressHub' ? '0px' : '20px')};
  padding-left: ${(props) => (props.pageContext === 'ExpressHub' ? '0px' : '20px')};
  max-width: 1232px;
  margin: auto;
  margin-bottom: 32px;
`;

export const ViewPort = styled.div`
  width: 550px;
  @media (max-width: 550px) {
    width: 100%;
    button {
      width: 100%;
    }
  }
`;

export const ADDON = styled.div`
  margin-bottom: 50px;
  @media (max-width: 450px) {
    margin-bottom: 0px;
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid #d8d8d8;
  }
`;

export const VIEW_PORT = styled.div`
  display: ${(props) => (props.type === 'DESKTOP' ? 'block' : 'none')};
  @media (max-width: 450px) {
    display: ${(props) => (props.type === 'MOBILE' ? 'block' : 'none')};
  }
`;

export const UPSELL = styled.div`
  margin-left: 21.5%;
  padding-bottom: 32px;
  .items {
    display: flex;
  }
  @media (max-width: 450px) {
    margin-left: 0%;
    padding-bottom: 32px;
    .items {
      display: block;
    }
  }
`;

export const GlobalStyle = createGlobalStyle`
  // Overrides untill VDS fixes there issues
  a {
    letter-spacing: 0;
  }
  [class^='StyledModalBody-sc'] {
    padding-left: 0px;
  }
  .container_ISPU .ispu-search-input-container {
    border-bottom: 0px !important;
  }
`;

/** *
 * VDS 3.0 common styles - START
 * */
export const WrapperDiv = styled.div`
  margin-top: ${(props) => props.mTop};
  margin-bottom: ${(props) => props.mBottom};
  margin-right: ${(props) => props.mRight};
  margin-left: ${(props) => props.mLeft};
  padding-top: ${(props) => props.pTop};
  padding-bottom: ${(props) => props.pBottom};
  padding-right: ${(props) => props.pRight};
  padding-left: ${(props) => props.pLeft};
`;

export const StyledVdsRow = styled(Row)`
  padding-left: ${(props) => props.pLeft};
  padding-right: ${(props) => props.pRight};
  padding-top: ${(props) => props.pTop};
  padding-bottom: ${(props) => props.pBottom};
  margin-left: ${(props) => props.mLeft};
  margin-right: ${(props) => props.mRight};
  margin-top: ${(props) => props.mTop};
  margin-bottom: ${(props) => props.mBottom};
  @media (max-width: 766px) {
    .noPadding {
      padding-left: 0px !important;
      padding-right: 0px !important;
    }
  }
`;

export const StyledVdsCol = styled(Col)`
  padding-left: ${(props) => props.pLeft};
  padding-right: ${(props) => props.pRight};
  padding-top: ${(props) => props.pTop};
  padding-bottom: ${(props) => props.pBottom};
  margin-left: ${(props) => props.mLeft};
  margin-right: ${(props) => props.mRight};
  margin-top: ${(props) => props.mTop};
  margin-bottom: ${(props) => props.mBottom};
  display: ${(props) => props.display};
  width: ${(props) => props.width};
  vertical-align: ${(props) => props.verticalAlign};
  @media (max-width: 766px) {
    .noPadding {
      padding-left: 0px !important;
      padding-right: 0px !important;
    }
    .mobileViewMaxWidth {
      max-width: 100% !important;
    }
  }
  @media (max-width: 766px) {
    .mobileViewMaxWidth {
      max-width: 100% !important;
    }
  }
`;

export const StyledWrapper = styled.div`
  ${({ styles }) => styles}
`;

export const mobileQuery = (style) => `@media (max-width: 480px) {${style}}`;
export const nonMobileQuery = (style) => `@media (min-width: 481px) {${style}}`;
export const nonDesktopQuery = (style) => `@media (max-width: 1023px) {${style}}`;
export const desktopQuery = (style) => `@media (min-width: 1025px) {${style}}`;
export const noPadMobile = mobileQuery('padding-left: 0px;padding-right: 0px;');
export const onlyMobilePad = nonMobileQuery('padding-left: 0px;padding-right: 0px;');
export const noPadMobileStrict = mobileQuery('padding-left: 0px !important;padding-right: 0px !important;');

export const StyledCol = styled(Col)`
  margin-top: ${(props) => props.top || '24px'};
  margin-bottom: ${(props) => props.bottom};
`;

export const LANDING = styled.div`
  .content {
    display: flex;
    @media (max-width: 1024px) {
      display: block;
      margin-left: ${isExpressCheckout() && !isDesktopResolution() ? '0px' : '10px'};
      margin-right: ${isExpressCheckout() && !isDesktopResolution() ? '0px' : '10px'};
    }
  }

  .mainContainer {
    width: 100%;
    @media (max-width: 1024px) {
      width: 100%;
    }
  }

  .notifyText {
    max-width: 1234px;
  }
  .notifyText p {
    font-weight: 400;
  }

  .orderContainer {
    width: 33.5%;
    padding-left: 40px;
    @media (max-width: 1024px) {
      width: 100%;
      padding-left: 0px;
      padding-top: 0px;
    }
  }
  #videoCallBlock > img {
    @media (max-width: 1024px) {
      height: 12px;
      width: 20px;
    }
  }
  .inlineVideoIcon {
    @media (max-width: 1024px) {
      font-size: 12px;
      font-weight: 400;
    }
  }

  .planHead5 [class^='TitleWrapper'] {
    margin-bottom: 0px;
  }
`;

export const DeviceQtyAvailableHeading = styled.div`
  display: flex;
  margin-bottom: 8px;
`;